import React from "react";

const Awards = () => {
    return (
        <div className="w-full text-gray-800 bg-white">

            {/* HERO / BREADCRUMB */}
            <section className="relative h-[420px]">
                <img
                    src="/images/company/award/hero.jpg"
                    alt="TechSPR Award Celebration"
                    className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/50" />
                <div className="relative max-w-7xl mx-auto px-6 h-full flex flex-col justify-center text-white">
                    <span className="text-sm opacity-80 mb-3">
                        &lt; Awards and Recognition
                    </span>
                    <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold max-w-4xl leading-tight">
                        TechSPR wins ASQ (American Society for Quality) award for
                        Innovation Excellence!
                    </h1>
                </div>
            </section>

            {/* CONTENT */}
            <section className="max-w-7xl mx-auto px-6 py-16">
                <div className="grid md:grid-cols-3 gap-10 items-start">

                    {/* TEXT */}
                    <div className="md:col-span-2 space-y-6 text-gray-700 leading-relaxed">
                        <p>
                            TechSPR is thrilled to announce that it has been honoured with the
                            prestigious American Society for Quality (ASQ) Award for
                            Innovation Excellence at the event held in New Delhi on Friday,
                            December 19, 2025. TechSPR's case study titled
                            <strong>
                                {" "}
                                “Managing Innovation at Scale to Lead in an AI-First World”
                            </strong>
                            , captured the Agentic AI journey of the Quality function
                            (Client Delivery Excellence) at the ASQ-SATEA Awards 2025 earning
                            TechSPR the Bronze Award in the Innovation Excellence category.
                        </p>

                        <p>
                            This recognition is particularly significant because the
                            ASQ-SATEA platform brings together leaders from a wide range of
                            industries, including manufacturing, power, insurance, and R&D,
                            and TechSPR distinguished itself as the sole representative from
                            the IT & ITES sector to earn this honour.
                        </p>

                        <p>
                            This award is a testament to our unwavering commitment to
                            adopting AI technologies that enhance operations and deliver
                            superior value to our customers. It reinforces TechSPR's role as
                            an AI-powered trusted partner for clients worldwide and inspires
                            us to set even higher benchmarks in quality and innovation.
                        </p>
                    </div>

                    {/* TROPHY IMAGE */}
                    <div className="md:col-span-1">
                        <img
                            src="/images/awards/trophy.jpg"
                            alt="ASQ Bronze Award Trophy"
                            className="rounded shadow-md"
                        />
                    </div>
                </div>
            </section>

            {/* CEREMONY IMAGE */}
            <section className="max-w-7xl mx-auto px-6 pb-20">
                <img
                    src="/images/awards/team.jpg"
                    alt="TechSPR ASQ Award Ceremony"
                    className="rounded-lg shadow"
                />
            </section>

            {/* FOOTER */}
            {/* <footer className="bg-purple-900 text-white py-6 text-sm">
                <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p>© 2026 TechSPR</p>
                    <div className="flex gap-6">
                        <a href="#" className="hover:underline">
                            Disclaimer
                        </a>
                        <a href="#" className="hover:underline">
                            Privacy
                        </a>
                        <a href="#" className="hover:underline">
                            Modern Slavery Statement
                        </a>
                    </div>
                    <div className="flex gap-4 text-lg">
                        <span>in</span>
                        <span>f</span>
                        <span>⧉</span>
                    </div>
                </div>
            </footer> */}

        </div>
    );
};

export default Awards;
